import { render, staticRenderFns } from "./platformAnnouncementList.vue?vue&type=template&id=5baa26d2&scoped=true"
import script from "./platformAnnouncementList.vue?vue&type=script&lang=js"
export * from "./platformAnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./platformAnnouncementList.vue?vue&type=style&index=0&id=5baa26d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa26d2",
  null
  
)

export default component.exports